// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disabled-btn[data-v-4d246a6c] {\n    cursor: no-drop;\n    color: #cccccc !important;\n}\n", ""]);
// Exports
module.exports = exports;
